module.exports = __webpack_public_path__ + "img/visa.716dfa5f.png";